export const LIBRARY_RESET_STATE = 'LIBRARY_RESET_STATE';
export const LIBRARY_CURRENT_ITEM = 'LIBRARY_CURRENT_ITEM';
 
export const LIBRARY_REQUEST_LOADING = 'LIBRARY_REQUEST_LOADING';
export const LIBRARY_REQUEST_SUCCESS = 'LIBRARY_REQUEST_SUCCESS';
export const LIBRARY_REQUEST_FAILED = 'LIBRARY_REQUEST_FAILED';
 
export const LIBRARY_CURRENT_ACTION = 'LIBRARY_CURRENT_ACTION';
export const LIBRARY_RESET_ACTION = 'LIBRARY_RESET_ACTION';